import { Disclosure, DisclosureButton } from '@reach/disclosure';
import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';

import AnimatedDisclosurePanel from '@ui/atoms/AnimatedDisclosurePanel';
import BasicText from '@ui/atoms/BasicText';

import Minus from '@assets/vectors/minus.inline.svg';
import Plus from '@assets/vectors/plus.inline.svg';

import theme from '@theme/FolxTheme/';

export interface IReadMoreProps {
	label: string;
	children?: ReactNode;
	className?: string;
	defaultOpen?: boolean;
}

const StyledDisclosure = styled.div`
	background: ${theme.colors.gray};
	border-radius: ${theme.radius.xl};
	padding: ${theme.spacing.smmd};
`;

const StyledDisclosureButton = styled(DisclosureButton)`
	display: flex;
	border: 0;
	width: 100%;
	align-items: center;
	justify-content: space-between;
`;

const StyledDisclosurePanel = styled(AnimatedDisclosurePanel)<{ open: boolean }>`
	padding-top: ${({ open }) => open && theme.spacing.sm};
	margin-bottom: ${({ open }) => open && theme.spacing.xs};
	transition: padding-top 0.25s, margin-bottom 0.25s;
`;

const ReadMore: FC<IReadMoreProps> = ({ children, className = '', label, defaultOpen = false }) => {
	const [open, setOpen] = useState(defaultOpen);

	return (
		<Disclosure open={open} onChange={() => setOpen((prev) => !prev)}>
			<StyledDisclosure className={className}>
				<StyledDisclosureButton>
					<BasicText variant="button">{label}</BasicText>
					{open ? <Minus /> : <Plus />}
				</StyledDisclosureButton>
				<StyledDisclosurePanel open={open} defaultOpen={defaultOpen}>
					{children}
				</StyledDisclosurePanel>
			</StyledDisclosure>
		</Disclosure>
	);
};

export default styled(ReadMore)``;
